import { UserStreamOrder } from '@eih-netbroker/common';
import { useCallback } from 'react';
import { useCollateralSummary } from '../../../modules/portfolio/services/useCollateralSummary';
import { useOpenOrders } from '../useOpenOrders';
import { useOrderLogs } from '../useOrderLogs';
import { useTradingClassification } from '../useTradingClassification';

export const useUserStreamOrder = () => {
  const { loadOrderLogs, orderLogs } = useOrderLogs();
  const { loadOrders } = useOpenOrders();
  const { loadCollateralSummary } = useCollateralSummary();
  const { tradingClassification } = useTradingClassification();

  return useCallback(
    (_message: UserStreamOrder) => {
      loadOrderLogs(orderLogs.periodType);
      loadOrders();
      // NN-7797 - If BUX was traded we need to refresh collateral - we do this when a trade happened, and he user is able to trade BUX.
      // We can't reliably figure out from the message (Order) if BUX was traded (we only have an ISIN),
      // so we narrow it using the users ability to trade BUX - reducing strain on the collateral-summary endpoint.
      if (tradingClassification?.allowBuxFutureTrade) {
        loadCollateralSummary(true);
      }
    },
    [
      loadCollateralSummary,
      loadOrderLogs,
      loadOrders,
      orderLogs.periodType,
      tradingClassification?.allowBuxFutureTrade,
    ],
  );
};
